export type AppResponseEnvelope = {
  success?: boolean;
  status?: string;
  statusCode?: number;
  message?: string;
  data?: unknown;
};

export function isAppResponseFailure(
  body: AppResponseEnvelope | null | undefined,
): boolean {
  if (!body) return true;
  if (body.success === false) return true;
  if (body.status && body.status !== 'success') return true;
  if (typeof body.statusCode === 'number' && body.statusCode >= 400) {
    return true;
  }
  return false;
}

export function readAccountLabel(body: AppResponseEnvelope): string {
  if (isAppResponseFailure(body)) {
    throw new Error(body?.message || 'Could not load account label.');
  }
  return typeof body?.data === 'string' ? body.data : '';
}
